import { getDemoData, matchRestRequest } from '../utils'

export const mockGetCompanyMembers = {
  shouldMock: (request) =>
    matchRestRequest(
      request,
      '/company/graphql_dispatch/current_company_c17690c4',
      'POST'
    ),
  getResponse: async () => {
    const demoData = getDemoData()
    return {
      data: {
        company: {
          members: demoData.companyMembers,
        },
      },
    }
  },
}
